import { Box, Button, CircularProgress, FormControl, IconButton, Menu, MenuItem, OutlinedInput, Pagination, Select, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPermissionData, getUserData } from "../../Actions/common";
import { getTenantAction } from "../../Actions/TenantActions";
import { exportTransactionHistoryAction, listTransactionDataAction } from "../../Actions/TransactionActions";
import { default as CoustomTooltip, default as CustomTooltip } from "../../Assets/customTheme/customtooltip";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { ITEMS_PER_PAGE_OPTIONS } from "../../config";
import { formatCurrency } from "../../utils/CommonFunctions";
import { formatDateTime } from "../Common/DateFormat";
import ExportDialog from "../Common/ExportModal";
import CustomSnackbar from "../Common/snackBar";
import TransactionCards from "./TransactionCards";
import renderStatusBadge from "../../utils/badges";
import { MyDescriptionOutlinedIcon, MyExportIcon, MySearchIcon } from "../../Assets/svg/MyIcons";
import DateRangePicker from "../Common/DateRangePicker";
import TransactionInvoiceModal from "./TransactionInvoiceModal";
import { PaylistTransactionDataAction, exportTransactionPaycentralHistoryAction } from "../../Actions/PaycentralAction"
import PaycentralTransactionInvoiceModal from "../PaycentralTransactions/TransactionInvoiceModal"
import { listAllCommonTenants } from "../../Actions/PaycentralAction";
import { listTripolaTransactionDataAction, getTripolaTenantsAction, exportTripolaTransactionHistoryAction } from "../../Actions/TripolaPlanActions"
import TripolaTransactionInvoiceModal from "./TripolaInvoiceModel"
import DataTable from "../../components/DataTable/DataTable";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      overflowY: "auto",
      borderRadius: "10px",
    },
  },
};

const getDefaultDateRange = () => {
  const end = new Date();
  const start = new Date();
  start.setMonth(start.getMonth() - 1);
  return { from: start, to: end };
};


const STATUS_OPTIONS = {
  qbot: [
    { label: "Pending", value: "0" },
    { label: "Success", value: "1" },
    { label: "Failed", value: "2" },
    { label: "Refund", value: "3" },
  ],
  paycentral: [
    { label: "Completed", value: "success" },
    { label: "Pending", value: "pending" },
  ],
  tripola: [
    { label: "Pending", value: "0" },
    { label: "Success", value: "1" },
    { label: "Failed", value: "2" },
    { label: "Refunded", value: "3" },
  ],
};



const TransactionSection = ({ isDashboardView = false }) => {
  const [selectedColumns, setSelectedColumns] = useState([]);

  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(isDashboardView ? 5 : ITEMS_PER_PAGE_OPTIONS[0]);

  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const [loading, setLoading] = useState(true);
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
  const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
  const [transactionData, setTransactionData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [enableFilterButton, setEnableFilterButton] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [shouldFetchData, setShouldFetchData] = useState(1);
  const [transactionType, setTransactionType] = useState("qbot");
  const [statusFilter, setStatusFilter] = useState("all");
  const [amountFilter, setAmountFilter] = useState("all");
  const [tenantFilter, setTenantFilter] = useState("all");
  const [filterValues, setFilterValues] = useState({
    search: "",
    status: "all",
    tenant: "all",
    dateRange: getDefaultDateRange(),
    transactionType: "qbot",
  });
  const [websiteDisabled, setWebsiteDisabled] = useState(true);
  const [merchantData, setMerchantData] = useState([]);

  // Date range states
  const defaultRange = getDefaultDateRange();
  const [selectedRange, setSelectedRange] = useState(defaultRange);
  const [startDate, setStartDate] = useState(defaultRange.from.toISOString());
  const [endDate, setEndDate] = useState(defaultRange.to.toISOString());
  const [exportType, setExportType] = useState("");
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [exportScope, setExportScope] = useState("thisPage");
  const [exportLoader, setExportLoader] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({});
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);


  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const permissionData = localStorage.getItem(`${userData?.id}_permissionData`)
    ? getPermissionData(`${userData?.id}_permissionData`)
    : [];
  const hasPermission = permissionData[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "transaction");
  const [shouldRefreshCards, setShouldRefreshCards] = useState(0);
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSnackBar = (severity = null, message) => {
    if (severity)
      setSnackbar({
        open: true,
        message: message || "Something went wrong...!",
        severity,
      });
  };

  const navigate = useNavigate();

  const handleTransactionTypeChange = (value) => {
    setTransactionType(value);

    // reset everything when switching
    setCurrentPage(1);
    setSearchValue("");
    setTransactionData([]);
    setStatusFilter("all");
    setTenantFilter("all");
    setAmountFilter("all");
    setFilterButtonDisabled(false);
    setResetButtonDisabled(true);
    // setShouldRefreshCards(0);

    // setShouldFetchData(1);
    // setShouldRefreshCards(prev => prev + 1);
  };

  const getMerchantListData = () => {
    let data = [];

    if (transactionType === "qbot") {
      getTenantAction(undefined, undefined, undefined, undefined, "1")
        .then((res) => {
          data = res?.data?.data || [];
          setMerchantData(data);
        })
        .catch((error) => {
          setSnackbar({
            open: true,
            message: error?.response?.data?.message || "Something went wrong.",
            severity: "error",
          });
        });

    } else if (transactionType === "paycentral") {
      listAllCommonTenants()
        .then((res) => {
          const rawData = res?.data?.data || [];
          data = rawData
            .filter((tenant) => tenant?.portalIds?.pId)
            .map((tenant) => ({
              ...tenant,
              pId: tenant.portalIds.pId,
            }));
          setMerchantData(data);
        })
        .catch((error) => {
          setSnackbar({
            open: true,
            message: error?.response?.data?.message || "Something went wrong.",
            severity: "error",
          });
        });

    } else if (transactionType === "tripola") {
      getTripolaTenantsAction()
        .then((res) => {
          data = res?.data?.data || [];
          data = data.map(tenant => ({
            ...tenant,
            pId: tenant.tId
          }));
          setMerchantData(data);
        })
        .catch((error) => {
          setSnackbar({
            open: true,
            message: error?.response?.data?.message || "Something went wrong.",
            severity: "error",
          });
        });
    }
  };

  useEffect(() => {
    getMerchantListData();
  }, [transactionType]);

  const getTransactionData = useCallback(async () => {
    setLoading(true);

    try {
      let res;

      if (transactionType === "qbot") {
        res = await listTransactionDataAction(
          selectedRowsPerPage,
          currentPage,
          searchValue,
          startDate,
          endDate,
          statusFilter,
          amountFilter,
          tenantFilter
        );

        setTransactionData(res?.data?.data || []);
        setTotalRecords(res?.data?.totalRecords || 0);

      } else if (transactionType === "paycentral") {
        res = await PaylistTransactionDataAction(
          selectedRowsPerPage,
          currentPage,
          statusFilter,
          tenantFilter,
          startDate,
          endDate,
          searchValue
        );

        setTransactionData(res?.data?.data?.data || []);
        setTotalRecords(res?.data?.data?.totalCount || 0);

      } else if (transactionType === "tripola") {
        res = await listTripolaTransactionDataAction(
          selectedRowsPerPage,
          currentPage,
          searchValue,
          startDate,
          endDate,
          statusFilter,
          amountFilter,
          tenantFilter
        );
        console.log("Responseee", res)
        setTransactionData(res?.data?.data || []);
        setTotalRecords(res?.data?.totalCount || 0);
      }

    } catch (error) {
      handleSnackBar("error", error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }, [
    transactionType,
    selectedRowsPerPage,
    currentPage,
    searchValue,
    startDate,
    endDate,
    statusFilter,
    amountFilter,
    tenantFilter
  ]);


  // useEffect(() => {
  //   getMerchantListData();
  // }, []);

  useEffect(() => {
    if (shouldFetchData) {
      getTransactionData();
      setShouldFetchData(0);
    }
  }, [shouldFetchData, getTransactionData]);

  const handleSearchApi = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (value.length === 0) {
      setFilterButtonDisabled(true);
    } else {
      setFilterButtonDisabled(false);
    }
  };

  const handleRangeChange = (range) => {
    setFilterButtonDisabled(false);
    setResetButtonDisabled(false);

    if (!range) {
      setSelectedRange({ from: undefined, to: undefined });
      setStartDate(null);
      setEndDate(null);
      return;
    }

    setSelectedRange(range);

    if (range.from) {
      const year = range.from.getFullYear();
      const month = range.from.getMonth();
      const day = range.from.getDate();
      const startDateObj = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
      setStartDate(startDateObj.toISOString());
    }

    if (range.to) {
      const year = range.to.getFullYear();
      const month = range.to.getMonth();
      const day = range.to.getDate();
      const endDateObj = new Date(Date.UTC(year, month, day, 23, 59, 59, 999));
      setEndDate(endDateObj.toISOString());
    }
  };

  const handleResetFilters = () => {
    const defaultRange = getDefaultDateRange();

    setLoading(true);
    setSearchValue("");
    setCurrentPage(1);
    setShouldFetchData(1);
    setEnableFilterButton(false);
    setLoading(true);
    setTransactionData([]);
    setSelectedRange(defaultRange);
    setStartDate(defaultRange.from.toISOString());
    setEndDate(defaultRange.to.toISOString());
    setStatusFilter("all");
    setAmountFilter("all");
    setTenantFilter("all");
    setResetButtonDisabled(true);
    setFilterButtonDisabled(true);
    setWebsiteDisabled(true);
    setShouldRefreshCards(prev => prev + 1);
  };

  const handleChangeDropdown = (e, filterName) => {
    const selectedValue = e.target.value;
    if (selectedValue === "all") {
      setFilterButtonDisabled(true);
    } else {
      setFilterButtonDisabled(false);
    }
    if (filterName === "statusFilter") {
      setStatusFilter(selectedValue);
    } else if (filterName === "amountFilter") {
      setAmountFilter(selectedValue);
    } else if (filterName === "tenantFilter") {
      if (selectedValue !== "all") {
        setWebsiteDisabled(false);
      } else {
        setWebsiteDisabled(true);
      }
      setTenantFilter(selectedValue);
    }
  };

  const handleFilterData = () => {
    setCurrentPage(1);
    setEnableFilterButton(true);
    setLoading(true);
    setShouldFetchData(1);
    setTransactionData([]);
    setFilterButtonDisabled(true);
    setResetButtonDisabled(false);
    setShouldRefreshCards(prev => prev + 1);

  };

  const SelectDropdown_SX = {
    "& .MuiSelect-select": {
      padding: "11px",
      textAlign: "start",
    },
    fieldset: {
      borderColor: "#e1e3ea !important",
      borderRadius: "30px",
    },
  };
  const qbotColumns = [
    {
      field: "companyName",
      headerName: "Company Name",
      minWidth: 160,
      flex: 1,
      renderCell: ({ row }) => row.companyName || "-",
    },
    {
      field: "orderId",
      headerName: "Order ID",
      minWidth: 180,
      flex: 1.2,
      renderCell: ({ row }) =>
        row?.orderId ? `#${row.orderId}` : "-",
    },
    {
      field: "transactionId",
      headerName: "Transaction ID",
      minWidth: 180,
      flex: 1.2,
    },
    {
      field: "amount",
      headerName: "Amount",
      minWidth: 120,
      flex: 0.8,
      renderCell: ({ row }) => formatCurrency(row?.amount) || "-",
    },
    {
      field: "billingCycle",
      headerName: "Billing Cycle",
      minWidth: 130,
      flex: 0.9,
      renderCell: ({ row }) => {
        const cycle = row?.billingCycle;
        return cycle === "monthly"
          ? "Monthly"
          : cycle === "yearly"
            ? "Yearly"
            : "-";
      },
    },
    {
      field: "transactionDate",
      headerName: "Transaction Date",
      minWidth: 180,
      flex: 1,
      renderCell: ({ row }) =>
        formatDateTime(row?.transactionDate, true),
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 0.9,
      renderCell: ({ row }) => {
        const statusMap = {
          0: { text: "Pending", status: "warning" },
          1: { text: "Success", status: "success" },
          2: { text: "Failed", status: "danger" },
          3: { text: "Refund", status: "default" },
        };

        const { text, status } =
          statusMap[String(row?.status)] || {
            text: "Unknown",
            status: "default",
          };

        return renderStatusBadge({ status, title: text });
      },
    },
    {
      field: "paymentMode",
      headerName: "Payment Mode",
      minWidth: 150,
      flex: 1,
      renderCell: ({ row }) => {
        const key = row?.paymentMode?.toLowerCase();

        const map = {
          offline: { text: "Offline Payment", status: "scheduled" },
          online: { text: "Online Payment", status: "warning" },
        };

        const { text, status } = map[key] || {
          text: "Unknown",
          status: "default",
        };

        return renderStatusBadge({ status, title: text });
      },
    },
    {
      field: "invoice",
      headerName: "Invoice",
      minWidth: 100,
      flex: 0.6,
      sortable: false,
      renderCell: ({ row }) => (
        <IconButton onClick={() => handleOpenInvoice(row)}>
          <MyDescriptionOutlinedIcon />
        </IconButton>
      ),
    },
  ];

  const paycentralColumns = [
    {
      field: "organizationName",
      headerName: "Organization Name",
      minWidth: 200,
      flex: 1.2,
    },
    {
      field: "oneTimeSetupFee",
      headerName: "One Time Setup Fee",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "ongoingMaintenanceFee",
      headerName: "Maintenance Fee",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "newMerchantSetupFee",
      headerName: "New Merchant Setup Fee",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "ongoingMaintenancePerMerchantFee",
      headerName: "Per Merchant Fee",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "totalFee",
      headerName: "Total Fee",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 0.8,
      renderCell: ({ row }) => {
        const status = (row?.status || "").toLowerCase();

        const map = {
          success: { title: "Completed", status: "success" },
          pending: { title: "Pending", status: "pending" },
        };

        return renderStatusBadge(
          map[status] || { title: "Unknown", status: "default" }
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      minWidth: 180,
      flex: 1,
      renderCell: ({ row }) =>
        formatDateTime(row.createdAt, true),
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 120,
      flex: 0.6,
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => (
        <CustomTooltip title="View Invoice" placement="top" arrow>
          <span>
            <button
              className="btn btn-light text-primary btn-icon"
              onClick={() => handleOpenInvoice(row)}
            >
              <MyDescriptionOutlinedIcon />
            </button>
          </span>
        </CustomTooltip>
      ),
    }
  ];

  const tripolaColumns = [
    {
      field: "tenantName",
      headerName: "Tenant Name",
      minWidth: 200,
      flex: 1.2,
      renderCell: ({ row }) => row.tenantName || "-",
    },
    {
      field: "transactionId",
      headerName: "Transaction ID",
      minWidth: 180,
      flex: 1.2,
    },
    {
      field: "amount",
      headerName: "Amount",
      minWidth: 120,
      flex: 0.8,
      renderCell: ({ row }) => formatCurrency(row?.amount) || "-",
    },
    {
      field: "orderId",
      headerName: "Order ID",
      minWidth: 180,
      flex: 1.2,
      renderCell: ({ row }) =>
        row?.orderId ? `#${row.orderId}` : "-",
    },
    {
      field: "billingCycle",
      headerName: "Billing Cycle",
      minWidth: 130,
      flex: 0.9,
      renderCell: ({ row }) => {
        const cycle = row?.billingCycle;
        return cycle === "monthly"
          ? "Monthly"
          : cycle === "yearly"
            ? "Yearly"
            : "-";
      },
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 130,
      flex: 0.9,
      renderCell: ({ row }) => {
        const statusMap = {
          pending: { text: "Pending", status: "warning" },
          success: { text: "Success", status: "success" },
          failed: { text: "Failed", status: "danger" },
          refunded: { text: "Refunded", status: "default" },
        };

        const { text, status } =
          statusMap[row?.status] || {
            text: "Unknown",
            status: "default",
          };

        return renderStatusBadge({ status, title: text });
      },
    },
    {
      field: "transactionDate",
      headerName: "Transaction Date",
      minWidth: 180,
      flex: 1,
      renderCell: ({ row }) =>
        formatDateTime(row?.transactionDate, true),
    },
    {
      field: "invoice",
      headerName: "Invoice",
      minWidth: 100,
      flex: 0.6,
      sortable: false,
      renderCell: ({ row }) => (
        <IconButton onClick={() => handleOpenInvoice(row)}>
          <MyDescriptionOutlinedIcon />
        </IconButton>
      ),
    },
  ];

  const columns =
    transactionType === "qbot"
      ? qbotColumns
      : transactionType === "paycentral"
        ? paycentralColumns
        : tripolaColumns;

  const filters = [
    {
      type: "search",
      name: "search",
      placeholder:
        transactionType === "paycentral"
          ? "Search with Organization Name"
          : transactionType === "tripola"
            ? "Search with Tenant Name"
            : "Search with Transaction ID",
    },

    {
      type: "status",
      name: "status",
      label: "Status",
      defaultValue: "all",
      options: [
        { label: "All", value: "all" },
        ...STATUS_OPTIONS[transactionType],
      ],
    },

    {
      type: "tenant",
      name: "tenant",
      label: "Tenant",
      defaultValue: "all",
      options: [
        { label: "All", value: "all" },
        ...(merchantData || []).map((item) => ({
          label:
            item.companyName ||
            item.organizationName ||
            `${item.firstName || ""} ${item.lastName || ""}`.trim(),
          value: item.pId,
        })),
      ],
    },

    {
      type: "dateRange",
      name: "dateRange",
      label: "Date Range",
    },
    {
      type: "select",
      name: "transactionType",
      label: "Portal",
      defaultValue: transactionType,
      options: [
        {
          label: "Qbot Transaction",
          value: "qbot",
        },
        {
          label: "Paycentral Transaction",
          value: "paycentral",
        },
        {
          label: "Tripola Transaction",
          value: "tripola",
        },
      ],
    },
  ];
  // const handlePdfDownload = async (pdf) => {
  //   const pdfUrl = `${MEDIA_URL}/${pdf}`;
  //   try {
  //     const response = await fetch(pdfUrl);
  //     const blob = await response.blob();
  //     const blobUrl = window.URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = blobUrl;
  //     link.setAttribute("download", pdf);
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     window.URL.revokeObjectURL(blobUrl);
  //   } catch (error) {
  //     console.error("Error downloading PDF:", error);
  //   }
  // };

  const handleRowsPerPageChange = (event) => {
    const newValue = parseInt(event.target.value);
    setSelectedRowsPerPage(newValue);
    setCurrentPage(1);
    setLoading(true);
    setShouldFetchData(1);
    setTransactionData([]);
  };

  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleExportOption = (type) => {
    setExportType(type);
    // Preselect visible columns except 'actions'
    let defaultColumns = columns.filter((col) => col.field !== "actions" && visibleColumns[col.field] !== false).map((col) => col.field);
    setSelectedColumns(defaultColumns);
    setExportDialogOpen(true);
    handleMenuClose();
  };


  const handleExportConfirm = async (exportColumnsArg) => {
    setExportLoader(true);

    let columnsData = exportColumnsArg || selectedColumns;

    const data = {
      exportType,
      exportScope,
      page: exportScope === "thisPage" ? currentPage : null,
      pageSize: exportScope === "thisPage" ? selectedRowsPerPage : null,
      status: statusFilter,
      amount: amountFilter,
      searchValue,
      startDate,
      endDate,
      exportColumns: columnsData,
      tenantDb: tenantFilter,
    };

    try {
      let res;

      if (transactionType === "paycentral") {
        res = await exportTransactionPaycentralHistoryAction(data);
      } else if (transactionType === "tripola") {
        res = await exportTripolaTransactionHistoryAction(data);
      } else {
        res = await exportTransactionHistoryAction(data);
      }

      // Rest of the export logic remains the same...
      if (res.type === "application/json") {
        setSnackbar({
          open: true,
          message: "There is no data exist for export.",
          severity: "info",
        });
      } else {
        const blob = new Blob([res]);
        const timestamp = new Date().getTime();

        let fileName;
        switch (exportType) {
          case "Excel":
            fileName = `${transactionType}_transaction_${timestamp}.xlsx`;
            break;
          case "PDF":
            fileName = `${transactionType}_transaction_report_${timestamp}.pdf`;
            break;
          default:
            fileName = `${transactionType}_export_${timestamp}.txt`;
        }

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);

        setSnackbar({
          open: true,
          message: "Data exported successfully",
          severity: "success",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Export failed",
        severity: "error",
      });
    } finally {
      handleMenuClose();
      setExportLoader(false);
      setExportScope("thisPage");
      setExportDialogOpen(false);
    }
  };

  const handleOpenInvoice = (transaction) => {
    setSelectedTransaction(transaction);
    setInvoiceModalOpen(true);
  };

  const handleCloseInvoice = () => {
    setInvoiceModalOpen(false);
    setSelectedTransaction(null);
  };
  const handleApplyFilters = (values) => {
    setFilterValues(values);

    setSearchValue(values.search || "");
    setStatusFilter(values.status || "all");
    setTenantFilter(values.tenant || "all");

    if (
      values.transactionType &&
      values.transactionType !== transactionType
    ) {
      handleTransactionTypeChange(values.transactionType);
    }

    if (values.dateRange?.from) {
      const from = new Date(values.dateRange.from);
      from.setHours(0, 0, 0, 0);
      setStartDate(from.toISOString());
    }

    if (values.dateRange?.to) {
      const to = new Date(values.dateRange.to);
      to.setHours(23, 59, 59, 999);
      setEndDate(to.toISOString());
    }

    setCurrentPage(1);
    setShouldFetchData(1);
    setShouldRefreshCards((prev) => prev + 1);
  };

  const handleResetTableFilters = () => {
    const defaultRange = getDefaultDateRange();

    setFilterValues({
      search: "",
      status: "all",
      tenant: "all",
      dateRange: defaultRange,
      transactionType: "qbot",
    });

    setSearchValue("");
    setStatusFilter("all");
    setTenantFilter("all");

    setSelectedRange(defaultRange);

    setStartDate(defaultRange.from.toISOString());
    setEndDate(defaultRange.to.toISOString());

    setCurrentPage(1);

    setShouldFetchData(1);
    setShouldRefreshCards((prev) => prev + 1);
  };

  return (
    <div>
      {!isDashboardView && <BreadcrumbsComponent />}

      {/* Summary Cards */}
      {!isDashboardView && (
        <div style={{ background: "#f1f5f9", padding: "1px" }}>
          <TransactionCards
            handleSnackBar={handleSnackBar}
            startDate={startDate}
            endDate={endDate}
            statusFilter={statusFilter}
            tenantFilter={tenantFilter}
            searchValue={searchValue}
            amountFilter={amountFilter}
            shouldRefresh={shouldRefreshCards}
            transactionType={transactionType}
          />
        </div>
      )}
      {/* End Summary Cards */}

      <DataTable
        toolbarActions={
          hasPermission?.canExport && (
            <>
              <Button
                className="btn btn-primary"
                aria-controls={isMenuOpen ? "export-menu" : undefined}
                aria-haspopup="true"
                disabled={exportLoader || transactionData.length === 0}
                onClick={handleExportClick}
              >
                <MyExportIcon className="text-white me-1" />
                Export
              </Button>

              <Menu
                id="export-menu"
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={() => handleExportOption("Excel")}>
                  Export as Excel
                </MenuItem>

                <MenuItem onClick={() => handleExportOption("PDF")}>
                  Export as PDF
                </MenuItem>
              </Menu>
            </>
          )
        }
        columns={columns}
        rows={transactionData}
        loading={loading}
        totalCount={totalRecords}
        page={currentPage}
        pageSize={selectedRowsPerPage}
        filters={filters}
        filterValues={filterValues}
        onFilterApply={handleApplyFilters}
        onFilterReset={handleResetTableFilters}
        onPageChange={(newPage) => {
          setCurrentPage(newPage);
          setShouldFetchData(1);
        }}
        onPageSizeChange={(newSize) => {
          setSelectedRowsPerPage(newSize);
          setCurrentPage(1);
          setShouldFetchData(1);
        }}
        getRowId={(row) => row.transactionId || row.id}

      />



      {exportDialogOpen && (
        <ExportDialog
          open={exportDialogOpen}
          onClose={() => setExportDialogOpen(false)}
          exportScope={exportScope}
          setExportScope={setExportScope}
          onExport={handleExportConfirm}
          columns={columns}
          selectedColumns={selectedColumns}
          setSelectedColumns={setSelectedColumns}
        />
      )}

      {invoiceModalOpen && (
        transactionType === "paycentral" ? (
          <PaycentralTransactionInvoiceModal
            open={invoiceModalOpen}
            handleClose={handleCloseInvoice}
            transactionData={selectedTransaction}
          />
        ) :
          transactionType === "tripola" ? (
            <TripolaTransactionInvoiceModal
              open={invoiceModalOpen}
              handleClose={handleCloseInvoice}
              transactionData={selectedTransaction}
            />
          ) : (
            <TransactionInvoiceModal
              open={invoiceModalOpen}
              handleClose={handleCloseInvoice}
              transactionData={selectedTransaction}
            />
          )
      )}

      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleCloseSnackbar}
      />
    </div>
  );
};

export default TransactionSection;
